import { resource } from "./resource";

const api = resource("/shift-rotation");

export const createShiftRotation = async (input = {}) => await api.post("", input);

export const getAllShiftRotations = async () => await api.get();

export const getSelfShiftRotation = async () => await api.get("/self");

export const getShiftRotationById = async (id) => await api.get(`/${id}`);

export const updateShiftRotation = async (id, input = {}) => await api.put(`/${id}`, input);
